import React from 'react'
import classNames from 'classnames'

import { CustomDropdownItemOption, DropDownItemOptionComponentProps } from '../../../../../components/SelectDropdown/SelectDropdown'

import { selectAccountId, selectSafeAuthenticatedUser } from '../../../../../store/auth/authSlice'
import { useGetAllUsersQuery } from '../../../../../store/user/user'
import { useAppSelector } from '../../../../../store/hooks'

import { UserTag } from '../../UserTag'

export const AllocationUserTagDropdownItemOption: React.FC<DropDownItemOptionComponentProps> = ({ optionId, optionLabel, onClick, selected }) => {
  const accountId = useAppSelector(selectAccountId)
  const currentUser = useAppSelector(selectSafeAuthenticatedUser)

  const { data: users } = useGetAllUsersQuery({ accountId, identityTypes: ['idp', 'external'] })

  const user = users?.data.find((u) => u.id === optionId)

  const userType = optionId === currentUser.id ? 'current' : user?.type

  return (
    <CustomDropdownItemOption
      role='button'
      onClick={selected ? () => {} : onClick}
      className={classNames('d-flex gap-2 align-items-center', { 'upload-user-dropdown-disabled-option': selected })}
    >
      <span className='text-truncate'>{optionLabel}</span>
      <UserTag className='user-tag-small' userType={userType} withoutStyle />
    </CustomDropdownItemOption>
  )
}
